<db-dialog-wrapper [dialog]="this" [height]="'218px'"
                   [width]="!!isMobile ? '100%' : '488px'" [fullScreen]="!!isMobile">
  <div class="remove-tag-dialog">
    <h1>{{'text_removeTag' | dbText}}</h1>
    <p [innerHTML]="'text_removeTagDesc' | dbText : {tagTitle: tagTitle}"></p>
    <div class="remove-tag-dialog__buttons">
      <a class="ds-btn" (click)="cancel(false)" [ngClass]="{'ds-btn-disabled': loading}">
        <span>{{"text_cancel" | dbText}}</span>
      </a>
      <a class="ds-btn ds-btn-red" (click)="confirm()" [ngClass]="{'ds-btn-disabled': loading}">
        <span *ngIf="!loading">{{'text_delete' | dbText}}</span>
        <db-loading-circular-spinner *ngIf="loading"></db-loading-circular-spinner>
      </a>
    </div>
  </div>
</db-dialog-wrapper>
